export enum AnalyticsEventName {
  Business = 'Business',
  Click = 'Click',
  View = 'View',
}
